import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { WhitelabelService } from 'src/app/core/services/whitelabel.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit, OnDestroy {

  logo: string = '../../../../assets/img/logo1.svg';

  @Output() close = new EventEmitter();

  constructor(
    private whitelabelService: WhitelabelService
  ) { }

  ngOnInit(): void {
    this.setBodyModalHidden(true);

    this.whitelabelService.logo
    .subscribe(
      logo => {
        console.log('logo', logo)
        if (logo)
          this.logo = logo;
      }
    );  
  }

  onClose() {
    this.close.emit();
    this.setBodyModalHidden(false);
  }

  setBodyModalHidden(isHidden: boolean) {
    document.getElementsByTagName('body').item(0).style.overflowY = isHidden ? 'hidden' : '';
  }

  isScrollbarClick(event): boolean {
    if(event.clientX + 18 >= document.documentElement.offsetWidth) {
      return false;
    }

    return true;
      
  }

  ngOnDestroy() {
    this.setBodyModalHidden(false);
  }

}
